import phina from 'phina.js'
import * as PIXI from 'pixi.js'
import GIF from 'gif.js'
import './ALizard/April'

import TextArea2 from './components/textarea2'
import Weather from './components/weather'
import BuffIcon from './components/buff_icon'
import Effect from './components/effect'
import HpGauge from './components/hp_gauge'
import GpGauge from './components/gp_gauge'
import Counter from './components/counter'

import DisplayComponent_attack from './opr/DisplayComponent/attack'
import DisplayComponent_buff from './opr/DisplayComponent/buff'
import DisplayComponent_defence from './opr/DisplayComponent/defence'
import DisplayComponent_event from './opr/DisplayComponent/event'
import DisplayComponent_heal from './opr/DisplayComponent/heal'
import DisplayComponent_hit from './opr/DisplayComponent/hit'
import DisplayComponent_show from './opr/DisplayComponent/show'
import DisplayComponent_skill from './opr/DisplayComponent/skill'
import ScenarioPlayer_base from './opr/ScenarioPlayer/base'
import SkillComponent_input from './opr/SkillComponent/input'

import DisplayScene from './scene/mydisplayscene'
import RequestScene from './scene/RequestScene'

import ManagerScene from './scene/ManagerScene'
import TitleScene from './scene/TitleScene'
import MainScene from './scene/MainScene'
import StoryScene from './scene/StoryScene'
import BattleScene from './scene/BattleScene'

import 'phina.form.js'
import 'phina.pixi.js'
// phina.globalize()
phina.global.GIF = GIF
phina.global.PIXI = PIXI
phina.global.Gauge = phina.ui.Gauge

TextArea2()
Weather()
BuffIcon()
Effect()
HpGauge()
GpGauge()
Counter()

DisplayComponent_attack()
DisplayComponent_buff()
DisplayComponent_defence()
DisplayComponent_event()
DisplayComponent_heal()
DisplayComponent_hit()
DisplayComponent_show()
DisplayComponent_skill()
ScenarioPlayer_base()
SkillComponent_input()

DisplayScene()
RequestScene()

ManagerScene()
TitleScene()
MainScene()
StoryScene()
BattleScene()  
